/**
 * Safely resolves a nested value from an unknown object using a dot-separated path.
 *
 * Notes:
 * - Returns `undefined` when any segment is missing or when the chain is not an object.
 * - Intended for reading dynamic structures such as `react-hook-form` nested `errors`.
 */
export const getObjectByPath = <TValue = unknown>(obj: unknown, path: string): TValue | undefined => {
    if (!obj) {
        return undefined;
    }

    const segments = path.split(".").filter(Boolean);
    let current: unknown = obj;

    for (const segment of segments) {
        if (current === null || current === undefined || typeof current !== "object") {
            return undefined;
        }
        current = (current as Record<string, unknown>)[segment];
    }

    return current as TValue | undefined;
};
